import { render, staticRenderFns } from "./GradientInput.vue?vue&type=template&id=21c60cf8&"
import script from "./GradientInput.vue?vue&type=script&lang=ts&"
export * from "./GradientInput.vue?vue&type=script&lang=ts&"
import style0 from "./GradientInput.vue?vue&type=style&index=0&id=21c60cf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports